import { addDays, addMonths, endOfMonth, format, getDay, setDate, startOfMonth } from 'date-fns';

export const CONFIRM_TEXT = 'I UNDERSTAND PRICES WILL RISE ON GOOGLE';
export const ALLOWED_API_TYPES = ['tabtrips_promotion', 'last_minute_deal'];
export const LEGACY_API_TYPES = ['night_owl_sale', 'long_stay'];

export const CATEGORIES = [
  { id: 'seasonal', label: 'Seasonal' },
  { id: 'festival', label: 'Festival' },
  { id: 'weekend', label: 'Weekend / Midweek' },
  { id: 'mega', label: 'Mega campaigns' },
  { id: 'lastminute', label: 'Last Minute fill' },
];

function ymd(d) {
  return format(d, 'yyyy-MM-dd');
}

function rangeDays(start, days) {
  const s = new Date(start);
  s.setHours(0, 0, 0, 0);
  return { start: s, end: addDays(s, days) };
}

function upcomingFriday(from) {
  const d = new Date(from);
  d.setHours(0, 0, 0, 0);
  const day = getDay(d);
  const add = day <= 5 ? 5 - day : 6;
  return addDays(d, add === 0 && day === 5 ? 0 : add);
}

function upcomingMonday(from) {
  const d = new Date(from);
  d.setHours(0, 0, 0, 0);
  const day = getDay(d);
  const add = day === 1 ? 0 : day === 0 ? 1 : 8 - day;
  return addDays(d, add);
}

function thisYearDate(from, monthIndex, day) {
  const y = from.getFullYear();
  let d = new Date(y, monthIndex, day);
  d.setHours(0, 0, 0, 0);
  if (d < from) d = new Date(y + 1, monthIndex, day);
  return d;
}

/** campaign_key → catalog card. All stay-date % only. */
export const PROMO_CATALOG = [
  { key: 'mega_sale', name: 'Mega Sale', type: 'tabtrips_promotion', category: 'mega', percent: 20, blurb: 'A bold % off on selected stay dates.', gradient: 'linear-gradient(135deg,#7c2d12 0%,#ea580c 55%,#fbbf24 100%)' },
  { key: 'mid_month_sale', name: 'Mid Month Sale', type: 'tabtrips_promotion', category: 'mega', percent: 15, blurb: 'A short mid-month stay-date window.', gradient: 'linear-gradient(135deg,#1e3a5f 0%,#0ea5e9 100%)' },
  { key: 'monsoon_sale', name: 'Monsoon Sale', type: 'tabtrips_promotion', category: 'seasonal', percent: 18, blurb: 'Stay dates through the monsoon season.', gradient: 'linear-gradient(135deg,#0f3d3e 0%,#0d9488 50%,#5eead4 100%)' },
  { key: 'payday_sale', name: 'Payday Sale', type: 'tabtrips_promotion', category: 'mega', percent: 12, blurb: 'End-of-month stay dates.', gradient: 'linear-gradient(135deg,#365314 0%,#84cc16 100%)' },
  { key: 'escape_sale', name: 'Escape Sale', type: 'tabtrips_promotion', category: 'seasonal', percent: 16, blurb: 'A multi-day escape on stay dates.', gradient: 'linear-gradient(135deg,#1e1b4b 0%,#6366f1 100%)' },
  { key: 'double_day_sale', name: 'Double Day Sale', type: 'tabtrips_promotion', category: 'mega', percent: 10, blurb: 'Two selected stay dates.', gradient: 'linear-gradient(135deg,#831843 0%,#f43f5e 100%)' },
  { key: 'bye_bye_summertime', name: 'Bye-Bye Summertime', type: 'tabtrips_promotion', category: 'seasonal', percent: 18, blurb: 'End-of-summer stay dates.', gradient: 'linear-gradient(135deg,#9a3412 0%,#fb923c 60%,#fde68a 100%)' },
  { key: 'long_weekend_sale', name: 'Long Weekend Sale', type: 'tabtrips_promotion', category: 'weekend', percent: 15, blurb: 'Holiday and weekend stay dates.', gradient: 'linear-gradient(135deg,#312e81 0%,#818cf8 100%)' },
  { key: 'halloween_sale', name: 'Halloween Sale', type: 'tabtrips_promotion', category: 'festival', percent: 15, blurb: 'Halloween-period stay dates.', gradient: 'linear-gradient(135deg,#ea580c 0%,#fb923c 55%,#fed7aa 100%)' },
  { key: 'black_friday', name: 'Black Friday', type: 'tabtrips_promotion', category: 'festival', percent: 22, blurb: 'Black Friday-period stay dates.', gradient: 'linear-gradient(135deg,#334155 0%,#64748b 50%,#94a3b8 100%)' },
  { key: 'end_of_year_sale', name: 'End of Year Sale', type: 'tabtrips_promotion', category: 'festival', percent: 20, blurb: 'December stay dates.', gradient: 'linear-gradient(135deg,#1e3a8a 0%,#c2410c 100%)' },
  { key: 'christmas_sale', name: 'Christmas Sale', type: 'tabtrips_promotion', category: 'festival', percent: 18, blurb: 'Christmas-period stay dates.', gradient: 'linear-gradient(135deg,#14532d 0%,#dc2626 100%)' },
  { key: 'new_year_sale', name: 'New Year Sale', type: 'tabtrips_promotion', category: 'festival', percent: 20, blurb: 'New Year stay dates.', gradient: 'linear-gradient(135deg,#312e81 0%,#f59e0b 100%)' },
  { key: 'republic_independence', name: 'National Day Sale', type: 'tabtrips_promotion', category: 'festival', percent: 15, blurb: 'National holiday stay dates.', gradient: 'linear-gradient(135deg,#ff9933 0%,#fff 45%,#138808 100%)' },
  { key: 'holi_sale', name: 'Holi Sale', type: 'tabtrips_promotion', category: 'festival', percent: 15, blurb: 'Holi stay dates.', gradient: 'linear-gradient(135deg,#db2777 0%,#facc15 50%,#22c55e 100%)' },
  { key: 'diwali_sale', name: 'Diwali Sale', type: 'tabtrips_promotion', category: 'festival', percent: 18, blurb: 'Diwali stay dates.', gradient: 'linear-gradient(135deg,#7c2d12 0%,#f59e0b 55%,#fef3c7 100%)' },
  { key: 'valentine_sale', name: 'Valentine Sale', type: 'tabtrips_promotion', category: 'festival', percent: 12, blurb: 'Valentine stay dates.', gradient: 'linear-gradient(135deg,#9f1239 0%,#fb7185 100%)' },
  { key: 'summer_escape', name: 'Summer Escape', type: 'tabtrips_promotion', category: 'seasonal', percent: 16, blurb: 'Summer stay dates.', gradient: 'linear-gradient(135deg,#0369a1 0%,#38bdf8 50%,#fde047 100%)' },
  { key: 'winter_getaway', name: 'Winter Getaway', type: 'tabtrips_promotion', category: 'seasonal', percent: 16, blurb: 'Winter stay dates.', gradient: 'linear-gradient(135deg,#0c4a6e 0%,#e0f2fe 100%)' },
  { key: 'festival_special', name: 'Festival Special', type: 'tabtrips_promotion', category: 'festival', percent: 15, blurb: 'Festival stay dates.', gradient: 'linear-gradient(135deg,#6b21a8 0%,#f97316 100%)' },
  { key: 'year_end_blowout', name: 'Year-End Blowout', type: 'tabtrips_promotion', category: 'mega', percent: 22, blurb: 'Late-year stay dates.', gradient: 'linear-gradient(135deg,#581c87 0%,#e11d48 100%)' },
  { key: 'off_season_booster', name: 'Off-Season Booster', type: 'tabtrips_promotion', category: 'seasonal', percent: 20, blurb: 'Low-demand stay dates.', gradient: 'linear-gradient(135deg,#334155 0%,#94a3b8 100%)' },
  { key: 'soft_opening', name: 'Soft Opening Special', type: 'tabtrips_promotion', category: 'mega', percent: 25, blurb: 'Opening-period stay dates.', gradient: 'linear-gradient(135deg,#9a3412 0%,#fdba74 100%)' },
  { key: 'anniversary_sale', name: 'Anniversary Sale', type: 'tabtrips_promotion', category: 'mega', percent: 15, blurb: 'Anniversary stay dates.', gradient: 'linear-gradient(135deg,#701a75 0%,#e879f9 100%)' },
  { key: 'wedding_season', name: 'Wedding Season Deal', type: 'tabtrips_promotion', category: 'seasonal', percent: 12, blurb: 'Wedding-season stay dates.', gradient: 'linear-gradient(135deg,#9f1239 0%,#fecdd3 100%)' },
  { key: 'clearance_stay', name: 'Clearance Stay Deal', type: 'tabtrips_promotion', category: 'mega', percent: 25, blurb: 'Clearance stay dates.', gradient: 'linear-gradient(135deg,#44403c 0%,#a8a29e 100%)' },
  { key: 'hot_deal_week', name: 'Hot Deal of the Week', type: 'tabtrips_promotion', category: 'mega', percent: 14, blurb: 'This week’s stay dates.', gradient: 'linear-gradient(135deg,#9a3412 0%,#f97316 100%)' },
  { key: 'tabtrips_exclusive', name: 'Tabtrips Exclusive', type: 'tabtrips_promotion', category: 'mega', percent: 15, blurb: 'A branded stay-date deal.', gradient: 'linear-gradient(135deg,#7c2d12 0%,#FF7700 100%)' },
  { key: 'weekend_stay_deal', name: 'Weekend Stay Deal', type: 'tabtrips_promotion', category: 'weekend', percent: 12, blurb: 'Fri–Sun stay nights.', gradient: 'linear-gradient(135deg,#1e40af 0%,#60a5fa 100%)' },
  { key: 'midweek_stay_deal', name: 'Midweek Stay Deal', type: 'tabtrips_promotion', category: 'weekend', percent: 14, blurb: 'Mon–Thu stay nights.', gradient: 'linear-gradient(135deg,#0f766e 0%,#5eead4 100%)' },
  { key: 'last_minute_fill', name: 'Last Minute Deal', type: 'last_minute_deal', category: 'lastminute', percent: 18, blurb: 'A near stay-date window — still fixed dates.', gradient: 'linear-gradient(135deg,#ef4444 0%,#fb923c 100%)' },
];

export function getCampaignByKey(key) {
  return PROMO_CATALOG.find((c) => c.key === key) || null;
}

export function suggestedRangeFor(key, from = new Date()) {
  const today = new Date(from);
  today.setHours(0, 0, 0, 0);
  const fri = upcomingFriday(today);
  const mon = upcomingMonday(today);

  switch (key) {
    case 'mega_sale':
      return rangeDays(today, 13);
    case 'mid_month_sale': {
      const midStart = setDate(startOfMonth(today), 10);
      const base = midStart >= today ? midStart : setDate(startOfMonth(addMonths(today, 1)), 10);
      return { start: base, end: addDays(base, 10) };
    }
    case 'monsoon_sale': {
      const start = thisYearDate(today, 5, 15);
      return { start, end: addDays(start, 90) };
    }
    case 'payday_sale': {
      const end = endOfMonth(today);
      const start = addDays(end, -4);
      if (end < today) {
        const nextEnd = endOfMonth(addMonths(today, 1));
        return { start: addDays(nextEnd, -4), end: nextEnd };
      }
      return { start: start < today ? today : start, end };
    }
    case 'escape_sale':
      return { start: fri, end: addDays(fri, 6) };
    case 'double_day_sale':
      return rangeDays(today, 1);
    case 'bye_bye_summertime': {
      const start = thisYearDate(today, 7, 15);
      return { start, end: addDays(start, 30) };
    }
    case 'long_weekend_sale':
      return { start: fri, end: addDays(fri, 2) };
    case 'halloween_sale': {
      const start = thisYearDate(today, 9, 25);
      return { start, end: addDays(start, 7) };
    }
    case 'black_friday': {
      const start = thisYearDate(today, 10, 24);
      return { start, end: addDays(start, 6) };
    }
    case 'end_of_year_sale': {
      const start = thisYearDate(today, 11, 15);
      return { start, end: new Date(start.getFullYear(), 11, 31) };
    }
    case 'christmas_sale': {
      const start = thisYearDate(today, 11, 20);
      return { start, end: addDays(start, 6) };
    }
    case 'new_year_sale': {
      let start = new Date(today.getFullYear(), 11, 28);
      start.setHours(0, 0, 0, 0);
      if (start < today && today.getMonth() !== 11) start = new Date(today.getFullYear(), 11, 28);
      if (start < today) start = today;
      return { start, end: addDays(start, 8) };
    }
    case 'republic_independence': {
      const republic = thisYearDate(today, 0, 26);
      const independence = thisYearDate(today, 7, 15);
      const next = republic <= independence ? republic : independence;
      return { start: next, end: addDays(next, 2) };
    }
    case 'holi_sale': {
      const start = thisYearDate(today, 2, 10);
      return { start, end: addDays(start, 5) };
    }
    case 'diwali_sale': {
      const start = thisYearDate(today, 9, 20);
      return { start, end: addDays(start, 8) };
    }
    case 'valentine_sale': {
      const start = thisYearDate(today, 1, 12);
      return { start, end: addDays(start, 3) };
    }
    case 'summer_escape': {
      const start = thisYearDate(today, 3, 1);
      return { start, end: addDays(start, 60) };
    }
    case 'winter_getaway': {
      const start = thisYearDate(today, 11, 1);
      return { start, end: addDays(start, 59) };
    }
    case 'festival_special':
      return rangeDays(today, 9);
    case 'year_end_blowout': {
      const start = thisYearDate(today, 11, 20);
      return { start, end: new Date(start.getFullYear(), 11, 31) };
    }
    case 'off_season_booster':
      return rangeDays(today, 20);
    case 'soft_opening':
      return rangeDays(today, 29);
    case 'anniversary_sale':
      return rangeDays(today, 6);
    case 'wedding_season': {
      const start = thisYearDate(today, 10, 1);
      return { start, end: addDays(start, 89) };
    }
    case 'clearance_stay':
      return rangeDays(today, 13);
    case 'hot_deal_week':
      return { start: today, end: addDays(today, 6) };
    case 'tabtrips_exclusive':
      return rangeDays(today, 20);
    case 'weekend_stay_deal':
      return { start: fri, end: addDays(fri, 2) };
    case 'midweek_stay_deal':
      return { start: mon, end: addDays(mon, 3) };
    case 'last_minute_fill':
      return { start: addDays(today, 1), end: addDays(today, 5) };
    default:
      return rangeDays(today, 13);
  }
}

export function getSuggestedCampaigns(from = new Date()) {
  const today = new Date(from);
  const month = today.getMonth();
  const date = today.getDate();
  const keys = [];

  if (month === 6 || month === 7) keys.push('monsoon_sale', 'escape_sale', 'bye_bye_summertime');
  if (date >= 22) keys.push('payday_sale');
  if (month === 9 || month === 10) keys.push('halloween_sale', 'black_friday', 'diwali_sale');
  if (month === 11) keys.push('christmas_sale', 'end_of_year_sale', 'new_year_sale', 'year_end_blowout');
  if (month === 1) keys.push('valentine_sale');
  if (month === 2) keys.push('holi_sale');
  if (month === 3 || month === 4) keys.push('summer_escape');
  if (month === 0 || month === 11) keys.push('winter_getaway');
  if (month === 7) keys.push('republic_independence');
  keys.push('weekend_stay_deal', 'hot_deal_week', 'last_minute_fill', 'tabtrips_exclusive');

  const seen = new Set();
  const out = [];
  keys.forEach((k) => {
    if (seen.has(k)) return;
    const camp = getCampaignByKey(k);
    if (!camp) return;
    seen.add(k);
    out.push(camp);
  });
  return out.slice(0, 6);
}

export function buildApiCatalogMap(apiCatalog) {
  const map = {};
  if (!Array.isArray(apiCatalog)) return map;
  apiCatalog.forEach((entry) => {
    const key = entry?.campaign_key;
    if (!key) return;
    map[key] = entry;
  });
  return map;
}

export function resolveCampaign(key, apiCatalogMap) {
  if (!key) return null;
  const local = getCampaignByKey(key);
  const api = apiCatalogMap?.[key];
  if (local && api) {
    return {
      ...local,
      key,
      name: api.campaign_name || api.display_name || api.name || local.name,
      type: api.type || local.type,
    };
  }
  if (local) return local;
  if (api) {
    return {
      key,
      name: api.campaign_name || api.display_name || api.name || humanizeCampaignKey(key),
      type: ALLOWED_API_TYPES.includes(api.type) ? api.type : 'tabtrips_promotion',
      category: 'mega',
      percent: 15,
      blurb: 'Stay-date discount.',
      gradient: 'linear-gradient(135deg,#5b21b6,#FF7700)',
    };
  }
  // Legacy / type-as-key rows (e.g. campaign_key === "tabtrips_promotion")
  return {
    key,
    name: humanizeCampaignKey(key),
    type: ALLOWED_API_TYPES.includes(key) ? key : 'tabtrips_promotion',
    category: 'mega',
    percent: 15,
    blurb: 'Stay-date discount.',
    gradient: 'linear-gradient(135deg,#FF7700,#fdba74)',
  };
}

export function humanizeCampaignKey(key) {
  if (!key || typeof key !== 'string') return 'Promotion';
  return key.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

export function humanizeDiscountType(type) {
  const map = {
    last_minute_deal: 'Last Minute Deal',
    night_owl_sale: 'Night Owl Sale',
    long_stay: 'Long Stay',
  };
  if (map[type]) return map[type];
  if (type === 'tabtrips_promotion') return humanizeCampaignKey(type);
  return String(type || 'Promotion').replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

/** List/card title — never default everything to "Tabtrips Promotion". */
export function titleForPromo(promo, apiCatalogMap) {
  if (!promo) return 'Promotion';
  const display = promo.display_name || promo.campaign_name;
  if (display && String(display).trim()) return String(display).trim();
  const camp = resolveCampaign(promo.campaign_key, apiCatalogMap);
  if (camp?.name) return camp.name;
  if (promo.campaign_key) return humanizeCampaignKey(promo.campaign_key);
  return humanizeDiscountType(promo.discount_type);
}

export function padConfirmCode(id) {
  return String(id ?? '').padStart(4, '0');
}

export function isLegacyPromo(promo) {
  if (!promo) return false;
  if (promo.is_legacy === true || promo.is_legacy === 1 || promo.is_legacy === '1') return true;
  return LEGACY_API_TYPES.includes(promo.discount_type);
}

export function isPromoActive(promo) {
  if (!promo) return false;
  if (promo.is_active === true || promo.is_active === 1 || promo.is_active === '1') return true;
  return String(promo.status) === '0';
}

export function isPromoEditable(promo) {
  if (!promo || isLegacyPromo(promo)) return false;
  if (promo.editable === false || promo.editable === 0 || promo.editable === '0') return false;
  return ALLOWED_API_TYPES.includes(promo.discount_type);
}

export function datesOverlap(aStart, aEnd, bStart, bEnd) {
  if (!aStart || !aEnd || !bStart || !bEnd) return false;
  return aStart <= bEnd && bStart <= aEnd;
}

export function parseYmd(value) {
  if (!value) return null;
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const d = new Date(value);
    d.setHours(0, 0, 0, 0);
    return d;
  }
  const s = String(value).slice(0, 10);
  const [y, m, d] = s.split('-').map(Number);
  if (!y || !m || !d) return null;
  const dt = new Date(y, m - 1, d);
  dt.setHours(0, 0, 0, 0);
  return dt;
}

export function toYmd(date) {
  if (!date) return '';
  return ymd(date);
}
